// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contents[data-v-43f74780],.wrapper[data-v-43f74780]{display:flex;justify-content:center;align-items:center}.square[data-v-43f74780]{width:24px;height:24px;background:#d0d7e0;border-radius:7px}", ""]);
// Exports
module.exports = exports;
